/* global gapi, google */

let tokenClient;
let gapiInited = false;
let gisInited = false;
let accessToken = null;

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

async function initGapi(apiKey, discoveryDocs) {
    if (gapiInited) return;
    await loadScript('https://apis.google.com/js/api.js');
    await new Promise((resolve) => {
        gapi.load('client', async () => {
            await gapi.client.init({ apiKey, discoveryDocs });
            gapiInited = true;
            resolve();
        });
    });
}

async function initGis(clientId, scope) {
    if (gisInited) return;
    await loadScript('https://accounts.google.com/gsi/client');
    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope,
        callback: (response) => {
            accessToken = response.access_token;
        },
    });
    gisInited = true;
}

async function ensureToken() {
    if (!accessToken) {
        await new Promise((resolve) => {
            tokenClient.callback = (resp) => {
                accessToken = resp.access_token;
                gapi.client.setToken({ access_token: accessToken });
                resolve();
            };
            tokenClient.requestAccessToken();
        });
    }
}

export default {
    install(Vue, { apiKey, clientId, scope, discoveryDocs }) {
        Vue.prototype.$google = {
            async init() {
                await initGapi(apiKey, discoveryDocs);
                await initGis(clientId, scope);
            },
            async login() {
                await this.init();
                await ensureToken();
            },
            logout() {
                accessToken = null;
                gapi.client.setToken('');
            },
            async listEvents(calendarId, params) {
                await this.login();
                return gapi.client.calendar.events.list({ calendarId, ...params });
            },
            async listCalendars() {
                await this.login();
                return gapi.client.calendar.calendarList.list();
            },
        };
    },
};
